import React, { createContext, useState, useRef, useContext, useEffect } from 'react';
// TODO: Replace these with your actual files
import song1 from '../assets/song1.mp3';
import cover1 from '../assets/albumcv.jpg';

import song2 from '../assets/song2.mp3'; 
import cover2 from '../assets/albumcv2.jpg'; // mf doom

import song3 from '../assets/song3.mp3'; // duffy
import cover3 from '../assets/albumcv3.jpg'; // 

import esthero from '../assets/esthero.mp3'; // 
import cover4 from '../assets/estherocv.png'; // be my man asa



export const playlistData = [
  { id: 1, title: 'lounge', artist: 'esthero', src: esthero, cover: cover4, duration: '4:58' },
  { id: 2, title: 'the friend i once had', artist: 'club 8', src: song1, cover: cover1, duration: '3:18' },
  { id: 3, title: 'fool for you', artist: 'duffy', src: song3, cover: cover3, duration: '3:45' },
  { id: 4, title: 'lavender buds', artist: 'mf doom', src: song2, cover: cover2, duration: '3:05' }
];
const MusicContext = createContext();
export const useMusic = () => useContext(MusicContext);

export const MusicProvider = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [currentTrackIndex, setCurrentTrackIndex] = useState(0);
  
  const audioRef = useRef(null);
  
  const audioCtxRef = useRef(null);
  const analyserRef = useRef(null);
  const sourceRef = useRef(null);

  const currentTrack = playlistData[currentTrackIndex];

  const initAudioNode = () => {
    if (!audioCtxRef.current && audioRef.current) {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      audioCtxRef.current = new AudioContext();
      analyserRef.current = audioCtxRef.current.createAnalyser();
      
      // FFT Tuning settings
      analyserRef.current.fftSize = 64; 
      
      // Decreased from 0.85 to 0.65 to make the bars drop much faster after a beat hits
      analyserRef.current.smoothingTimeConstant = 0.65; 
      
      analyserRef.current.minDecibels = -90; 
      
      // Lowered the ceiling from -15 to -25 so high frequencies hit the max height easier
      analyserRef.current.maxDecibels = -25; 
      
      sourceRef.current = audioCtxRef.current.createMediaElementSource(audioRef.current);
      sourceRef.current.connect(analyserRef.current);
      analyserRef.current.connect(audioCtxRef.current.destination);
    }
  };

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.load(); 
      if (isPlaying) {
        audioRef.current.play().catch(e => console.log('Autoplay blocked:', e));
      }
    }
  }, [currentTrackIndex,isPlaying]);

  const executeMusicCommand = (cmd) => {
    if (cmd === 'music') {
      setIsVisible(true);
      initAudioNode(); 
      setTimeout(() => {
        if (audioCtxRef.current && audioCtxRef.current.state === 'suspended') {
          audioCtxRef.current.resume();
        }
        if (audioRef.current) {
          audioRef.current.play().catch(err => console.log('Autoplay prevented:', err));
        }
      }, 50); 
    } else if (cmd === 'end music') {
      setIsVisible(false);
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    }
  };

  const togglePlay = () => {
    if (!audioRef.current) return;
    initAudioNode();
    if (audioCtxRef.current && audioCtxRef.current.state === 'suspended') {
      audioCtxRef.current.resume();
    }
    
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
  };

  const nextTrack = () => {
    setCurrentTrackIndex((prev) => (prev + 1) % playlistData.length);
    setIsPlaying(true);
  };

  const prevTrack = () => {
    setCurrentTrackIndex((prev) => (prev - 1 + playlistData.length) % playlistData.length);
    setIsPlaying(true);
  };

  const selectTrack = (index) => {
    setCurrentTrackIndex(index);
    setIsPlaying(true);
  };

  const handleTimeUpdate = () => {
    if (audioRef.current) {
      const current = audioRef.current.currentTime;
      const duration = audioRef.current.duration;
      if (duration > 0) {
        setProgress((current / duration) * 100);
      }
    }
  };

  return (
    <MusicContext.Provider value={{ 
      isVisible, isPlaying, progress, currentTrack, playlistData,
      executeMusicCommand, togglePlay, nextTrack, prevTrack, selectTrack,
      handleTimeUpdate, setIsPlaying, audioRef, analyserRef 
    }}>
      {children}
    </MusicContext.Provider>
  );
};